var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',{class:['alert', 'alert-dismissible', _vm.getMessageClass()]},[_c('span',{staticClass:"close",attrs:{"aria-label":"close"},on:{"click":_vm.onCloseClick}},[_vm._v("×")]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.value.text)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }